import { FaTimes } from "react-icons/fa";
import { Modal } from "reactstrap";
import { createNotification } from "../Common/CreateNotification";
import { useEffect } from "react";
import noScroll from "no-scroll";

const SelectImageModal = ({
  uploadModal,
  setUploadModal,
  setImageSelectModal,
  images,
  selectedImages,
  setSelectedImages,
  isFetchImageLoading,
}) => {
  // console.log(images);
  useEffect(() => {
    if (uploadModal) {
      noScroll.on();
    } else {
      noScroll.off();
    }
    return () => {
      noScroll.off();
    };
  }, [uploadModal]);
  return (
    <Modal centered size="xl" isOpen={uploadModal}>
      <div
        onClick={() => {
          setUploadModal(false);
        }}
        className="position-absolute cursor-pointer"
        style={{ top: 6, right: 10 }}
      >
        <FaTimes size={20} />
      </div>
      <div className="p-3">
        <div>
          <h4>Choose Images</h4>
        </div>
        <div>
          <p>Upload a new image</p>
          <button
            className="btn btn-primary btn-sm"
            onClick={() => {
              setImageSelectModal(true);
            }}
          >
            Upload new image
          </button>
          {/* <input multiple={false} type="file" className="form-control" onChange={e => { setFile(e.target.files[0]); setDefaultFile(URL.createObjectURL(e.target.files[0])) }} /> */}
        </div>
        <div className="d-flex my-3">
          <hr className="w-50" />
          <h4 className="px-3">OR</h4>
          <hr className="w-50" />
        </div>
        <div>
          <div className="d-flex flex-wrap justify-content-between">
            <div className="d-flex">
              <p className="lead my-auto">Select Images: </p>
              &nbsp;
              <div
                className="my-auto d-flex justify-content-center align-items-center"
                style={{
                  height: 40,
                  width: 40,
                  borderRadius: 20,
                  background: "#EC008C",
                  color: "#ffffff",
                }}
              >
                {selectedImages.length}
              </div>
            </div>
            <button
              onClick={() => {
                if (selectedImages.length <= 0) {
                  createNotification(
                    "error",
                    "Please select atleast one image"
                  );
                } else {
                  setUploadModal(false);
                }
              }}
              style={{ background: "#EC008C" }}
              className="btn btn-sm text-white"
            >
              Done
            </button>
          </div>
          <div
            className="col-12 d-flex flex-wrap mt-3 sc-modal-content"
            style={{ maxHeight: "55vh", overflowY: "auto" }}
          >
            {isFetchImageLoading ? (
              Array(5)
                .fill()
                .map((_, i) => (
                  <div
                    key={i}
                    className="col-6 col-sm-4 col-lg-3 col-2 shine p-1"
                    style={{ height: 100 }}
                  ></div>
                ))
            ) : images.length > 0 ? (
              images &&
              images.map((image, i) => (
                <div
                  onClick={() => {
                    if (selectedImages.includes(Object.keys(image)[0])) {
                      // console.log("already selected");
                      setSelectedImages(
                        selectedImages.filter(
                          (img) => img !== Object.keys(image)[0]
                        )
                      );
                    } else {
                      setSelectedImages((prevState) => [
                        ...prevState,
                        Object.keys(image)[0],
                      ]);
                    }
                  }}
                  key={i}
                  className="col-6 col-sm-4 col-lg-3 col-xl-2"
                  style={{ padding: "2px" }}
                >
                  <div
                    style={{
                      border: selectedImages.includes(Object.keys(image)[0])
                        ? "4px solid #EC008C"
                        : "4px solid transparent",
                    }}
                  >
                    <img
                      alt="select-img-modal"
                      src={Object.values(image)[0]}
                      className="img-fluid"
                    />
                  </div>
                </div>
              ))
            ) : (
              <div>
                <p className="text-danger">
                  You haven't uploaded any images yet. Please upload new images
                  to continue selecting the images.
                </p>
                <button
                  onClick={() => {
                    setImageSelectModal(true);
                  }}
                  style={{ background: "#EC008C" }}
                  className="btn btn-sm text-white"
                >
                  Upload new image
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SelectImageModal;
